import { caseActions } from '../store/case'
import { filterActions } from '../store/filter'
import { tasksActions } from '../store/tasks'
import {
    deletedTaskIdsInPatch,
    isDeletedRecord,
    isDeletedTask,
    isTaskRecord,
} from './noteDelete'

const QUEUE_FOLDERS = ['notes', 'task_notes', 'tasks']

export function dispatchWorkQueueRemoval(dispatch, caseId, itemId) {
    if (caseId == null || itemId == null) {
        return
    }
    QUEUE_FOLDERS.forEach((folder) => {
        dispatch(filterActions.removeWholeItemFromArray({
            case_id: caseId,
            folder,
            itemId,
        }))
    })
}

export function dispatchDeletedTasksRemoved(dispatch, notes) {
    const ids = deletedTaskIdsInPatch(notes)
    if (ids.length === 0) {
        return
    }
    dispatch(tasksActions.removeTasksByIds(ids))
}

export function applyDeletedNotesPatch(dispatch, notes, caseId) {
    if (!Array.isArray(notes)) {
        return
    }
    notes.filter(isDeletedRecord).forEach((item) => {
        dispatchWorkQueueRemoval(dispatch, caseId, item.id)
    })
    dispatchDeletedTasksRemoved(dispatch, notes)
}

export function applyDeleteSuccess(dispatch, deleted, { caseId, activeCaseId, shell }) {
    const id = deleted?.id
    if (id == null) {
        return
    }

    if (activeCaseId != null && Number(activeCaseId) === Number(caseId)) {
        dispatch(caseActions.pushWholeItemInArray({
            folder: 'notes',
            itemId: id,
            item: deleted,
        }))
    }

    dispatchWorkQueueRemoval(dispatch, caseId, id)

    if (isDeletedTask(deleted) || isTaskRecord(deleted)) {
        dispatch(tasksActions.removeTasksByIds([id]))
        dispatch(tasksActions.setRefreshApi())
    }

    shell?.removeOpenListItem?.(id)
}
